module.exports = __webpack_public_path__ + "static/media/boy-2.b73ac0f5.svg";